import React from 'react';
import styled from 'styled-components';

interface BottomFixedActionProps {
  children: React.ReactNode;
  /** 데스크톱에서 내부 컨텐츠 최대 너비 (px). 지정 안 하면 전체 너비 사용 */
  maxWidth?: number;
  /** 데스크톱 정렬 방식 */
  align?: 'center' | 'right';
  /** 상단 보더 표시 여부 (결제/신청 화면 등) */
  showBorderTop?: boolean;
}

const FixedButtonContainer = styled.div<{ $showBorderTop?: boolean }>`
  position: fixed;
  /* 앱 바텀 네비 높이만 고려 (safe-area는 바텀 네비에서 처리) */
  bottom: var(--bottom-nav-height, 75px);
  left: 0;
  right: 0;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 16px 16px;
  z-index: 1100; /* BottomNavigation(z-index: 1000) 위에 위치 */
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  border-top: ${({ $showBorderTop }) => ($showBorderTop ? '1px solid #e9ecef' : 'none')};

  @media (min-width: 768px) {
    bottom: 0; /* 웹에서는 항상 바닥에 고정 */
    padding: 20px 0;
  }
`;

const WebContainer = styled.div<{ $align: 'center' | 'right' }>`
  width: 100%;

  @media (min-width: 768px) {
    max-width: 1200px;
    display: flex;
    justify-content: ${({ $align }) => ($align === 'right' ? 'flex-end' : 'center')};
    padding: 0 24px;
  }
`;

const ButtonWrapper = styled.div<{ $maxWidth?: number }>`
  width: 100%;

  @media (min-width: 768px) {
    ${({ $maxWidth }) => ($maxWidth ? `max-width: ${$maxWidth}px;` : '')}
  }
`;

export default function BottomFixedAction({
  children,
  maxWidth,
  align = 'center',
  showBorderTop = false,
}: BottomFixedActionProps) {
  return (
    <FixedButtonContainer $showBorderTop={showBorderTop}>
      <WebContainer $align={align}>
        <ButtonWrapper $maxWidth={maxWidth}>{children}</ButtonWrapper>
      </WebContainer>
    </FixedButtonContainer>
  );
}
